<ul class="breadcrumb" itemscope itemtype="https://schema.org/BreadcrumbList">
  <li *ngFor="let item of breadcrumb; let i = index" class="breadcrumb__list" [ngClass]="{'hide-in-mobile': item.hideInMobile}" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
    <a itemprop="item" [smNavigate]="item.link">
      <span itemprop="name">{{ item.label}}</span>
    </a>
    <span class="icon" smSvgIcon="keyboard_arrow_right"></span>
    <meta itemprop="position" content="{{i + 1}}" />
  </li>
</ul>
